// src/components/auth/ProtectedRoute.js
import React from "react";
import { useAuth } from "../../context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  // 1. Check if the user is logged in
  if (!currentUser) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to. This allows us to send them along to that page after login.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 2. Check if the user has the correct role for the route
  if (allowedRoles && !allowedRoles.includes(currentUser.role)) {
    // If the user is logged in but has the wrong role, redirect them to their own portal's home page.
    let homePath = "/fan"; // Default home path
    switch (currentUser.role) {
      case "creator":
        homePath = "/dashboard";
        break;
      case "admin":
        homePath = "/admin";
        break;
      case "fan":
      default:
        homePath = "/fan";
        break;
    }
    return <Navigate to={homePath} replace />;
  }

  // 3. If everything is correct, render the child components
  return children;
};

export default ProtectedRoute;
